<template>
  <div class="my_issue_topic">
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item_top">
            <div class="logo">
              <img :src="item.customerService.avatarUrl" v-if="item.customerService && item.customerService.avatarUrl" v-load="'oAvatar'" />
              <img src="@assets/img/empty.png" v-else />
            </div>
            <div class="details">
              <div class="line">
                <span class="name" v-if="item.customerService">{{ item.customerService.name || item.customerService.nickName }}</span>
                <span class="job" v-if="item.customerService">{{ item.customerService.jobTitle }}</span>
              </div>
              <div class="info2" v-if="item.exhibitor.company">{{ item.exhibitor.company.nameEn }}</div>
            </div>
          </div>

          <div class="item_center" v-if="item.customerUsers">{{ item.customerUsers.email }}</div>

          <div class="item_bottom">
            <span>{{ item.type }}</span>
            {{ item.content }}
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "my-issue-topic",
  data() {
    return {
      loading: false, //联系我的加载状态
      finished: false, //联系我的是否完成状态
      list: [], //联系我的列表
      pageIndex: 0,
      pageSize: 20,
      queryTalk: {},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
  },
  created() {},
  methods: {
    ...mapActions({
      delTalk: "my/delTalk",
      LinkHotPub: "linkTo/LinkHotPub",
      LinkToHotTopDetails: "linkTo/LinkToHotTopDetails",
      graphqlPost:'en/graphqlPostByZXS',
    }),
    //去话题详情
    goToHotTopDetails(item) {
      if (item.auditState == "WAIT") {
        this.$toast("Audit failure");
        return;
      }
      this.LinkToHotTopDetails(item.id);
    },
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    async getList() {
      let query = `
        query($query: QueryInput!){
          exhibitorAppointmentQuery {
            query(query:$query) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              companyUsersId
              content
              createAt
              exhibitionId
              exhibitorId
              id
              customerService {
                id
                name
                email
                nickName
                phone
                jobTitle
                company
                avatarUrl
              }
              customerUsers {
                email
              }
              member {
                name
                nickName
                phone
                jobTitle
                company
              }
              exhibitor {
                company {
                  nameEn
                }
              }
              memberId
              state
              type
            }
          }
        }
        }
      `;
      let where = {
        Equal: {
          n: "memberId",
          v: this.userInfo.inMember.memberId,
        },
        EqualA: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        EqualB: {
          n: "state",
          v: 0, // 已回应
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let queryWhere = {
        query: {
          where: JSON.stringify(where),
          order: JSON.stringify(order),
          page: this.pageIndex,
          size: this.pageSize,
        },
      };
      let opt = {
        query: query,
        variables: queryWhere,
      };
      let data = await this.graphqlPost(opt);
      if(data) {
        let res = JSON.parse(JSON.stringify(data.data.exhibitorAppointmentQuery.query));
        let arr = res.items.filter((c) => {
          // 过滤没有客服信息
          return c.customerService;
        });
        if (this.pageIndex == 1) {
          this.list = arr;
        } else {
          this.list = [...new Set([...this.list, ...arr])];
        }
        this.loading = false;
        if (!res.hasNextPage) {
          this.finished = true;
        }
      }
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      this.getList();
    },
    //删除
    async delStateNoTalk(id) {
      let res = await this.delTalk(id);
      if (res.result) {
        this.list = this.list.filter((item) => item.id != id);
        this.$toast.success("Deletion succeeded");
      } else {
        this.$toast.fail("Deletion failed");
      }
    },
    //重新编辑
    topicEdit(item) {
      let imgArr = [];
      if (item.imgUrls && item.imgUrls.length) {
        item.imgUrls.map((e) => {
          imgArr.push({ url: e });
        });
      }
      localStorage.setItem("content", item.content);
      localStorage.setItem("relepase", JSON.stringify(item.themes));
      if (imgArr.length) {
        localStorage.setItem("Upimg", JSON.stringify(imgArr));
      }
      this.LinkHotPub({ id: false, talkId: item.id });
    },
  },
};
</script>

<style scoped lang="scss">
//展品列表
.my_issue_topic {
  .list_wrap {
    .item {
      background-color: #fff;
      margin-bottom: 0.3rem;
      box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      padding: 0.2rem;
      margin-bottom: 0.3rem;
      &:last-child {
        margin-bottom: 0;
      }
      .item_top {
        color: #333;
        display: flex;
        .logo {
          position: relative;
          width: 0.88rem;
          height: 0.88rem;
          margin-right: 0.14rem;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        .details {
          .line {
            display: flex;
            align-items: flex-end;
            margin-bottom: 0.16rem;
            .name {
              font-size: 0.26rem;
              margin-right: 0.1rem;
              font-weight: 400;
            }
            .job {
              font-size: 0.22rem;
              color: #666;
            }
          }
          .info2 {
            font-size: 0.22rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .txt {
          width: 2rem;
          padding-top: 0.16rem;
          text-align: right;
          font-size: 0.2rem;
          color: #bfbfbf;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .create_time {
          margin-left: auto;
          flex-shrink: 0;
          font-size: 0.2rem;
          color: #bfbfbf;
        }
        &-gx {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-b {
          display: flex;
          .cclb {
            &-l {
              font-size: 0.2rem;
              width: 80%;
              padding-top: 0.13rem;
              .txt2 {
                color: #ffcc00;
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .txt3 {
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            &-r {
              width: 20%;
              text-align: right;
              .btn {
                height: 0.48rem;
                line-height: 0.48rem;
                display: inline-block;
                padding: 0 0.2rem;
                background-color: #f85b0f;
                border-radius: 0.04rem;
              }
            }
          }
        }
      }
      .item_center {
        font-size: 0.26rem;
        line-height: 0.36rem;
        color: #333;
        margin-top: 0.22rem;
      }
      .item_bottom {
        width: 100%;
        background-color: #f2f2f2;
        font-size: 0.26rem;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0.1rem 0.16rem;
        margin-top: 0.3rem;
        span {
          background-color: #d1e9ff;
          border-radius: 4px;
          display: inline-block;
          color: #1890ff;
          padding: 0.03rem 0.08rem;
          font-size: 0.2rem;
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
